module.exports = __webpack_public_path__ + "static/media/Screenshot 2026-03-13 at 04.19.48.cd50e36c.png";